import { useNavigate } from 'react-router-dom'
import { SquareKanban } from 'lucide-react'
import { SectionCard } from '../../patterns/SectionCard'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ProjectsCard({ boards }: { boards: any[] | null }) {
  const navigate = useNavigate()
  return (
    <SectionCard icon={<SquareKanban size={14} />} title="My projects" fill noBodyPadding>
      {(!boards || boards.length === 0) ? (
        <div className="px-5 py-6 text-center text-xs text-muted-foreground/70">No boards with your tasks yet.</div>
      ) : (
        <div className="divide-y divide-border/60">
          {boards.map((b) => {
            const total = Math.max(1, b.dist.todo + b.dist.inProgress + b.dist.done)
            const pct = (n: number) => `${(n / total) * 100}%`
            return (
              <button key={b.boardId} type="button" onClick={() => navigate(b.link)} className="w-full text-left px-5 py-3 hover:bg-accent/40 transition">
                <span className="flex items-center gap-2">
                  <span className="flex-1 min-w-0 text-sm font-medium truncate">{b.name}</span>
                  {b.unread > 0 && <span className="shrink-0 text-[11px] tabular-nums bg-primary/15 text-primary rounded-full px-2 py-0.5">{b.unread} new</span>}
                </span>
                <span className="block text-xs text-muted-foreground mt-0.5">
                  {b.myOverdue > 0 && <span className="text-rose-400">{b.myOverdue} overdue · </span>}
                  {b.dueThisWeek > 0 ? `${b.dueThisWeek} due this week` : `${b.myOpen} open`}
                </span>
                <span className="mt-1.5 flex h-1 rounded-full overflow-hidden bg-muted">
                  <span className="bg-muted-foreground/30" style={{ width: pct(b.dist.todo) }} />
                  <span className="bg-blue-500/80" style={{ width: pct(b.dist.inProgress) }} />
                  <span className="bg-emerald-500/80" style={{ width: pct(b.dist.done) }} />
                </span>
              </button>
            )
          })}
        </div>
      )}
    </SectionCard>
  )
}
